import UserViewPage from "./UserViewPage";

export default UserViewPage;
